module.exports = new __parcel__URL__("step_two_vector_light.9f7e6b93.png").toString();